import { atom, atomFamily } from 'recoil';

import { QueryStatus } from 'react-query';

import {
  FuneralHomeInfoPopulated,
  FuneralHomeInfoList,
} from './funeralHomeInfo.interface';

export const funeralHomeInfoListStatusAtom = atom<QueryStatus>({
  key: 'funeralHomeInfoListStatusAtom',
  default: 'idle',
});

export const funeralHomeInfoListDataAtom = atom<FuneralHomeInfoList | null>({
  key: 'funeralHomeInfoListDataAtom',
  default: null,
});

//* 단건(추가정보 이미지까지 populate) — 관리자 수정/미리보기용
export const funeralHomeInfoStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'funeralHomeInfoStatusAtomFamily',
  default: 'idle',
});

export const funeralHomeInfoDataAtomFamily = atomFamily<
  FuneralHomeInfoPopulated | null,
  string
>({
  key: 'funeralHomeInfoDataAtomFamily',
  default: null,
});
